import i18next from 'i18next';
import DashboardLogo from '../../../../../components/Shared/Icons/DashboardLogo';
import permissions from '../../../../permissions';
import Claims from '../../../../../components/Claims/List';
import EditClaim from '../../../../../components/Claims/Item/EditClaim';

// const CLAIM_ROUTE_LIST_DS = {
//   path: '/:currentAccountUuid/accounts/:accountUuid/claims',
//   exact: true,
//   additional: {
//     component: Claims,
//     title: i18next.t('titles:claimsReporting'),
//     protected: true,
//     icon: DashboardLogo,
//     permission: permissions.CLAIMS_GET,
//   },
// };

const CLAIM_ROUTE_LIST = {
  path: '/:currentAccountUuid/claims',
  exact: true,
  additional: {
    component: Claims,
    title: i18next.t('titles:claimsReporting'),
    protected: true,
    icon: DashboardLogo,
    permission: permissions.CLAIMS_GET,
    getUrl: '/accounts/:currentAccountUuid/claims',
  },
};

const CLAIM_ROUTE_EDIT_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/claims/:claimUuid',
  exact: true,
  parentRoute: CLAIM_ROUTE_LIST, //CLAIM_ROUTE_LIST_DS,
  additional: {
    component: EditClaim,
    title: i18next.t('titles:editClaim'),
    protected: true,
    icon: DashboardLogo,
    permission: permissions.CLAIMS_GET,
  },
};




const CLAIM_ROUTE_EDIT = {
  path: '/:currentAccountUuid/claims/:claimUuid',
  exact: true,
  parentRoute: CLAIM_ROUTE_LIST,
  additional: {
    component: EditClaim,
    title: i18next.t('titles:editClaim'),
    protected: true,
    icon: DashboardLogo,
    permission: permissions.CLAIMS_GET,
  },
};

export const CLAIM_ROUTES = {
  // ------- For child accounts ------
  // listDS: CLAIM_ROUTE_LIST_DS,
  editDS: CLAIM_ROUTE_EDIT_DS,

  // ------- For current accounts ------
  list: CLAIM_ROUTE_LIST,
  edit: CLAIM_ROUTE_EDIT,
};
